import clsx from 'clsx';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { createPortal } from 'react-dom';

dayjs.extend(utc);

export interface SegmentStats {
  criticalCount: number;
  minorCount: number;
  startTime: number;
  endTime: number;
}

interface Props {
  x: number;
  y: number;
  stats: SegmentStats;
  timezone: string;
}

export function StatsPreview(props: Props) {
  const { x, y, stats, timezone } = props;
  const { criticalCount, minorCount, startTime, endTime } = stats;

  const formatTime = (timestamp: number) => {
    return dayjs.utc(timestamp).tz(timezone).format('HH:mm:ss');
  };

  const isCritical = criticalCount > 0;

  return (
    <>
      {createPortal(
        <div
          className={clsx(
            'pointer-events-none fixed z-50 rounded-md px-3 py-2 text-xs shadow-lg',
            isCritical ? 'bg-earth-500' : 'bg-sage-500'
          )}
          style={{
            left: `${x}px`,
            top: `${y}px`,
            transform: 'translate(-50%, calc(-100% - 8px))',
          }}
        >
          <div className="flex flex-col gap-1">
            {criticalCount > 0 && (
              <div className="font-medium text-orange-500">
                {criticalCount.toString().padStart(2, '0')} Critical
              </div>
            )}
            {minorCount > 0 && (
              <div className="font-medium text-green-400">
                {minorCount.toString().padStart(2, '0')} Minor
              </div>
            )}
            <div className="pt-1 text-[10px]">
              <div className="text-gray-300">{formatTime(startTime)}</div>
              <div className="text-gray-300">{formatTime(endTime)}</div>
            </div>
          </div>
          {/* Arrow pointing down */}
          <div
            className={clsx(
              'absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent',
              isCritical ? 'border-t-earth-500' : 'border-t-sage-500'
            )}
          ></div>
        </div>,
        document.body
      )}
    </>
  );
}

export default StatsPreview;
